// src/components/SolutionsSection/index.js - 카드 표시 문제 수정
import React, { useEffect, useState } from 'react';
import './SolutionsSection.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const SolutionsSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  // 솔루션 카드 데이터
  const solutionsData = [
    {
      id: 1,
      category: 'Exchange Engine',
      title: '거래소 엔진',
      description: '안정적이고 빠른 금융 거래 솔루션',
      defaultImg: require('../../aimg/logo_bitcoin.png'),
      hoverImg: require('../../aimg/logo_bitcoin.png'),
      mobileDefaultImg: '/assets/images/solutions/m_exchange_default.webp',
      mobileHoverImg: '/assets/images/solutions/m_exchange_hover.webp',
      buttonText: '거래소 엔진',
      url: '/services/exchange',
      aosDelay: '100',
      features: [
        '초당 10만건 이상 주문처리',
        '실시간 모니터링 시스템',
        '장애 대비 이중화 구성',
        '고급 보안 프로토콜'
      ]
    },
    {
      id: 2,
      category: 'Deep Learning',
      title: '딥러닝',
      description: '복잡한 패턴을 학습하는 AI 솔루션',
      defaultImg: require('../../aimg/logo_deepleaning1.png'),
      hoverImg: require('../../aimg/logo_deepleaning1.png'),
      mobileDefaultImg: '/assets/images/solutions/m_deeplearning_default.webp',
      mobileHoverImg: '/assets/images/solutions/m_deeplearning_hover.webp',
      buttonText: '딥러닝 기술',
      url: '/services/deeplearning',
      aosDelay: '300',
      features: [
        '자연어 처리 기술',
        '이미지 및 영상 인식',
        '예측 모델링',
        '자동화된 학습 시스템'
      ]
    },
    {
      id: 3,
      category: 'AI Modeling',
      title: 'AI 모델링',
      description: '맞춤형 AI 모델 개발 및 적용',
      defaultImg: require('../../aimg/logo_ai_modeling1.png'),
      hoverImg: require('../../aimg/logo_ai_modeling1.png'),
      mobileDefaultImg: '/assets/images/solutions/m_ai_modeling_default.webp',
      mobileHoverImg: '/assets/images/solutions/m_ai_modeling_hover.webp',
      buttonText: 'AI 모델링',
      url: '/services/aimodeling',
      aosDelay: '500',
      features: [
        '비즈니스 인텔리전스',
        '데이터 시각화 도구',
        '실시간 분석 대시보드',
        '의사결정 지원 시스템'
      ]
    },
    {
      id: 4,
      category: 'ISMS Certification',
      title: 'ISMS 인증',
      description: '정보보호 관리체계 인증',
      defaultImg: require('../../aimg/logo_isms.png'),
      hoverImg: require('../../aimg/logo_isms.png'),
      mobileDefaultImg: '/assets/images/solutions/m_isms_default.webp',
      mobileHoverImg: '/assets/images/solutions/m_isms_hover.webp',
      buttonText: '보안 인증',
      url: '/services/isms',
      aosDelay: '700',
      features: [
        '정보보호 관리 체계',
        '보안 취약점 진단',
        '위험 평가 및 대응',
        '정기적인 보안 점검'
      ]
    },
  ];

  useEffect(() => {
    // 애니메이션 초기화
    AOS.init({
      once: true,  // 애니메이션을 한 번만 실행
      offset: 50,  // 요소가 화면에 나타날 시점(px) 설정
      duration: 800, // 애니메이션 지속 시간
      delay: 0,
    });

    // 컴포넌트 마운트 시 카드 보이도록 설정
    setIsVisible(true);

    // 추가: 페이지 새로고침 또는 다시 접근 시에도 애니메이션이 작동하도록
    window.addEventListener('load', refreshAOS);
    window.addEventListener('popstate', refreshAOS);

    return () => {
      window.removeEventListener('load', refreshAOS);
      window.removeEventListener('popstate', refreshAOS);
    };
  }, []);

  // AOS 애니메이션 리프레시 함수
  const refreshAOS = () => {
    setTimeout(() => {
      AOS.refresh();
      setIsVisible(true);
    }, 100);
  };

  // 카드 클릭 핸들러
  const handleClickCard = (url) => {
    window.location.href = url;
  };

  // isVisible이 true일 때만 카드를 렌더링
  return (
    <div className="solutions-section">
      <div className="rn-l-center">
        <div className="main-txt f-pop f-r f-center" data-aos="fade-up">
          G-Vision Technology
        </div>
        <div className="main-ttl f-b f-bk f-center" data-aos="fade-up">
          AI 기술의 선두주자
        </div>
        <div className="main-desc f-l f-bk f-center" data-aos="fade-up">
          <strong className="f-b blue-txt">그래비젼</strong>이 혁신적인 솔루션을 제공합니다
        </div>

        <div id="solutions-wrap" className="solutions-wrap">
          {isVisible && solutionsData.map((solution) => (
            <div
              key={solution.id}
              className="solutions-card"
              data-aos="flip-left"
              data-aos-delay={solution.aosDelay}
              data-aos-duration="800"
              onClick={() => handleClickCard(solution.url)}
            >
              <div className="txt f-center f-r f-pop">{solution.category}</div>
              <div className="ttl f-center f-b">{solution.title}</div>
              <div className="desc f-center f-r">{solution.description}</div>
              <div className="img-grp tab-hide">
                <img
                  loading="lazy"
                  src={solution.defaultImg}
                  alt={solution.title}
                  className="img-card default"
                />
                <img
                  loading="lazy"
                  src={solution.hoverImg}
                  alt={solution.title}
                  className="img-card hover"
                />
                <div className="feature-list">
                  {solution.features.map((feature, index) => (
                    <div key={index} className="feature-item">{feature}</div>
                  ))}
                </div>
              </div>
              <div className="img-grp tab-show">
                <img
                  loading="lazy"
                  src={solution.mobileDefaultImg}
                  alt={solution.title}
                  className="img-card default"
                />
                <img
                  loading="lazy"
                  src={solution.mobileHoverImg}
                  alt={solution.title}
                  className="img-card hover"
                />
                <div className="feature-list">
                  {solution.features.map((feature, index) => (
                    <div key={index} className="feature-item">{feature}</div>
                  ))}
                </div>
              </div>
              <button className="btn btn-solutions f-m">
                <span>
                  <strong className="underline blue-txt">{solution.buttonText}</strong> 자세히 보기
                </span>
                &nbsp;
                <i className="icon icon-arrow-right-01 default"></i>
                <i className="icon icon-arrow-right-02 hover"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SolutionsSection;